// for IE11
declare global {
  interface Window {
    msCrypto: Crypto
  }
}
const browserCrypto = window.crypto || window.msCrypto

/**
 * Generate random bytes.
 * @param size The size of the byte array to generate.
 * @returns An ArrayBuffer containing the random bytes.
 */
export function randomBytes(size: number): ArrayBuffer {
  const array = new Uint8Array(size)
  browserCrypto.getRandomValues(array)
  return array.buffer
}
